import { useCallback, useContext } from "react"

import { CommonFiltersParityContext } from '../context'
import { getOptionValues } from './index'


export default function useParityAnalyzerFilters() {
    const { state, setState } = useContext(CommonFiltersParityContext)

	const updateState = useCallback(newState => {
        setState(state => ({ ...state, ...newState }))
	}, [setState])

    const setDeviceParity = useCallback(op => {
        updateState({ deviceParity: op })
    }, [updateState])

	const setOtas = useCallback(op => {
		if (Array.isArray(op) && op?.length > 0)
            updateState({ otas: getOptionValues(op)})
	}, [updateState])

	const setMetas = useCallback(op => {
		updateState({ metas: getOptionValues(op) })
	}, [updateState])

	const setInfo = useCallback(op => {
		updateState({ info: getOptionValues(op) })
	}, [updateState])

	return {
		metas: state.metas, otas: state.otas, deviceParity: state.deviceParity, info: state.info,
        updateState, setOtas, setMetas, setDeviceParity, setInfo
	}
}